<script setup lang="ts">
import { onClickOutside } from '@vueuse/core'
//import { useOverlay } from '@/composables/useOverlay';
//const { setOverlayOpen, isOverlayOpen } = useOverlay();

const menuRef = templateRef<HTMLElement>('menuRef');
onClickOutside(menuRef, () => {
    closeMenu();
});
const route = useRoute();
const items = [
    {
        label: 'Ansatte',
        to: '/ansatte'
    },
    {
        label: 'Kontakt',
        to: '/kontakt'
    },
    {
        label: 'Åpningstider',
        to: '/apningstider'        
    },
    {
        label: 'Tjenester',
        to: '/tjenester'
    },
    {
        label: 'Priser',
        to: '/priser'
    }
]
const isMenuOpen = useState('isMenuOpen', () => false);
const closeMenu = () => {
    isMenuOpen.value = false;
    //setOverlayOpen(false);
}
const toggleMenu = () => {
    isMenuOpen.value = !isMenuOpen.value;
    //setOverlayOpen(isMenuOpen.value);
}
</script>
<template>
    <div class="@container mainColorBackground">
        <div class="flex m-4">
            <NuxtLink to="/">
                <img src="/assets/images/sacredheart256.png" alt="Sacred Heart" class="h-16 md:h-24" />
            </NuxtLink>
            <!-- Mobile menu -->
            <div class="md:hidden grow flex flex-col" ref="menuRef">

                <Icon class="md:hidden! place-self-end hover:scale-110 transition-all duration-300" @click="toggleMenu"
                    name="hugeicons:menu-01" size="2em" />


                <div class="flex flex-col justify-around gap-3 items-center p-6 p-t-8 rounded-bl-lg shadow-lg menu fixed z-40 md:z-0"
                    :class="{ 'hidden': !isMenuOpen }" style=" top: 0; right: 0; min-width: 60%;">
                    <NuxtLink v-for="item in items" :key="item.to" :to="item.to" @click="closeMenu"
                        class="my-2 font-semibold text-xl " :class="{ 'underline': route.path === item.to }">
                        {{ item.label }}
                    </NuxtLink>
                </div>
            </div>
            <!-- Desktop menu -->
            <div class="hidden md:block grow content-center">
                <div class="flex flex-row justify-around flex-col ">
                    <NuxtLink v-for="item in items" :key="item.to" :to="item.to"
                        class="mx-2 font-semibold text-xl mainColorText hover:underline"
                        :class="{ 'underline': route.path === item.to }">
                        {{ item.label }}
                    </NuxtLink>
                </div>
            </div>
        </div>
        <!-- <div class="mainColorGradient py-2"></div> -->
    </div>
</template>
